import { Panel } from '@epam/promo';

import { TaskHeader } from 'components/tasks/TaskHeader';
import { FormBody } from '../FormBody';
import css from './TaskForm.module.scss';

export const TaskForm = () => (
  <Panel shadow cx={css.page__container}>
    <TaskHeader />
    <FormBody />
  </Panel>
);
